module.exports = __webpack_public_path__ + "static/media/Check Blue.3de2cfcc.svg";